export const sendGA4Event = (
  eventName: string,
  params: Record<string, string | undefined | null>
): void => {
  if (typeof window === 'undefined') return;

  const win = window as Window & {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };

  win.dataLayer = win.dataLayer || [];

  const cleaned = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null)
  ) as Record<string, string>;

  if (typeof win.gtag === 'function') {
    win.gtag('event', eventName, cleaned);
    return;
  }

  win.dataLayer.push({
    event: eventName,
    ...params
  });
};
